import React, { Component }                 from 'react';
import { connect }                          from 'react-redux';
import { bindActionCreators }               from 'redux';
import * as viewElements                    from '../../../infrastructure/actions/creators/view-elements';
import UiKit                                from '../../uikit';
import {
    Container,
    ContentWrapper,
    CloseButton
}                                           from './components';
import { 
    TransitionGroup,
    CSSTransition
}                                           from 'react-transition-group';

export class Toast extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.zIndex = '301';
    }

    onCloseHandler(toast) {
        let {
            actions
        } = this.props;
        actions.removeToast(toast)
    }

    removeToastWithTimeout(toast) {
        let {
            actions
        } = this.props;
        setTimeout(() => {
            actions.removeToast(toast)
        },  500002250)
    }

    removeToast(toast) {
        let {
            actions
        } = this.props;
        actions.removeToast(toast);
    }

    createTitleComponent(toast) {
        if(toast.get('title'))
            return <span className="marketkit-toast-title">{ toast.get('title') }</span>;
        return null;
    }

    render() {
        let { toasts } = this.props;
        
        return (
            <UiKit.Portal
                zIndex={ this.zIndex }
            >
                <TransitionGroup className="toast-transition">
                    {
                        toasts && toasts.map((t, i) => {
                            return(
                                <CSSTransition
                                    appear      = { true }
                                    unmountOnExit
                                    classNames  = 'toast'
                                    timeout     = { 200 }
                                    key         = {`toast-${i}`}
                                    onEntered   = { () => this.removeToastWithTimeout(t) }
                                >
                                    <Container
                                        position = { t.get('position') } 
                                        type     = { t.get('type') }
                                        topBuffer= { 73 * i }
                                    >
                                        <ContentWrapper>
                                            <span className="marketkit-toast-message" dangerouslySetInnerHTML={{ __html: t.get('message') }}></span>
                                        </ContentWrapper>
                                        <CloseButton
                                            onClose={ () => this.removeToast(t) }
                                        />
                                    </Container>
                                </CSSTransition>
                            )
                        })
                    }
                </TransitionGroup> 
            </UiKit.Portal>
        )
    }
}

const mapStateToProps = state => ({
    toasts: state.getIn(['ui', 'runtime', 'viewElements', 'toasts'])
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(viewElements, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Toast);